<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
   @media screen and (max-width: 760px){
     .el-dialog{
       width: 100% !important;
     }
     .el-pagination{
       overflow-x: scroll !important;
     }
   }
    @media screen and (min-width: 1200px) and (max-width: 1980px){
      .el-dialog{
        width: 60% !important;
      }
    }
</style>
